import { EventOffer } from '../types/content';

export const eventOffers: EventOffer[] = [
  {
    id: 'wedding',
    price: 350,
    title: { en: 'Wedding photos with horses', ru: 'Свадебная фотосессия с лошадьми', et: 'Pulmafotod hobustega' },
    description: {
      en: 'A groomed, calm horse and a handler for up to 2 hours — in the hay meadow, forest or on the beach.',
      ru: 'Ухоженная спокойная лошадь и коневод до 2 часов — на лугу со стогами, в лесу или на пляже.',
      et: 'Hoolitsetud rahulik hobune ja hobusehoidja kuni 2 tunniks — heinamaal, metsas või rannas.',
    },
  },
  {
    id: 'photoshoot',
    price: 120,
    unit: { en: '/ hour', ru: '/ час', et: '/ tund' },
    title: { en: 'Photo session with horses', ru: 'Фотосессия с лошадьми', et: 'Fotosessioon hobustega' },
    description: {
      en: 'Family, portrait or brand shoots. Bring your photographer or ask us to recommend one.',
      ru: 'Семейные, портретные или рекламные съёмки. Приходите со своим фотографом или попросите нас порекомендовать.',
      et: 'Pere-, portree- või brändipildid. Tule oma fotograafiga või küsi meilt soovitust.',
    },
  },
  {
    id: 'celebration',
    price: 250,
    title: { en: 'Birthdays & team days', ru: 'Дни рождения и корпоративы', et: 'Sünnipäevad ja meeskonnapäevad' },
    description: {
      en: 'Short rides for the group, a picnic in the hay barn and time with the horses. Up to 8 guests riding.',
      ru: 'Короткие прогулки для группы, пикник в сенном сарае и общение с лошадьми. До 8 всадников.',
      et: 'Lühikesed matkad grupile, piknik heinaküünis ja aeg hobustega. Kuni 8 ratsanikku.',
    },
  },
];
